import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Join from './views/Join.vue'
import Test from './views/Test.vue'
import CreateGame from './views/CreateGame.vue'
import CreateExploration from './views/CreateExploration.vue'
import CreateMining from './views/CreateMining.vue'
import Game from './views/Game.vue'
import GameControl from './views/GameControl.vue'
import JoinGame from './views/JoinGame.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: '404',
      component: Home
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/create',
      name: 'create',
      component: CreateGame
    },
    {
      path: '/create/exploration',
      name: 'createExploration',
      component: CreateExploration
    },
    {
      path: '/create/mining',
      name: 'createMining',
      component: CreateMining
    },
    {
      path: '/join',
      name: 'join',
      component: Join
    },
    {
      path: '/join/:pin',
      name: 'join-game',
      component: JoinGame,
      props: true
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/game/:pin/:uid',
      name: 'game',
      component: Game,
      props: true
    },
    {
      path: '/game/:pin',
      name: 'gamecontrol',
      component: GameControl,
      props: true
    },
  ]
})
